export const DRIFT_VISIT_COUNTS = 'visitCounts'
export const IS_CHAT_FRAME_OPEN = 'isChatFrameOpen'
export const USE_ENTER_TO_SUBMIT = 'useEnterToSubmit'

export const LocalStorageItems = [DRIFT_VISIT_COUNTS, IS_CHAT_FRAME_OPEN, USE_ENTER_TO_SUBMIT]
